module.exports = function() {
  return new Worker(__webpack_public_path__ + "c19408874c2f484855f5.worker.js");
};